module.exports = __webpack_public_path__ + "static/media/statusInactive.d1f5cdb5.svg";